import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-embedded-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `<main class="embedded"><router-outlet /></main>`,
  styleUrls: ['./embedded-layout.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmbeddedLayoutComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    document.body.classList.add('authhub-embedded');
  }

  ngOnDestroy(): void {
    document.body.classList.remove('authhub-embedded');
  }
}
